import Donnee from '../donnee.model'

export default {
  add: ({ POST }, donnee) =>
    new Promise((resolve, reject) => {
      if (!(donnee instanceof Donnee)) {
        return reject(new Error(
          `Erreur paramètre : Donnee attendu mais reçu "${donnee.constructor.name}"`
        ))
      }
      return POST(`donnees`, donnee)
        .then(reponse => {
          const data = reponse.data
          if (reponse.status === 200 && data.id) {
            const donnee = new Donnee(data)
            resolve(donnee)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
}
